import { c as _c } from "react/compiler-runtime";
import { type MintCountdownState, useMintCountdownState } from "@/hooks/useMintCountdownState";
import NowMintingCountdownActive from "./NowMintingCountdownActive";
import NowMintingCountdownError from "./NowMintingCountdownError";
import NowMintingCountdownFinalized from "./NowMintingCountdownFinalized";
import NowMintingCountdownLoading from "./NowMintingCountdownLoading";
import NowMintingCountdownSoldOut from "./NowMintingCountdownSoldOut";
interface NowMintingCountdownProps {
  readonly nftId: number;
}
export default function NowMintingCountdown(t0) {
  const $ = _c(2);
  const {
    nftId
  } = t0;
  const state = useMintCountdownState(nftId);
  let t1;
  if ($[0] !== state) {
    t1 = <div className="tw-group tw-relative tw-mt-auto"><NowMintingCountdownContent state={state} /></div>;
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function NowMintingCountdownContent(t0) {
  const $ = _c(6);
  const {
    state
  } = t0;
  switch (state.type) {
    case "loading":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <NowMintingCountdownLoading />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "error":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <NowMintingCountdownError />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "sold_out":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <NowMintingCountdownSoldOut />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "finalized":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <NowMintingCountdownFinalized />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "countdown":
      {
        let t1;
        if ($[4] !== state.countdown) {
          t1 = <NowMintingCountdownActive countdown={state.countdown} />;
          $[4] = state.countdown;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
  }
}